const LANDING_URL = (process.env.REACT_APP_LANDING_URL || 'https://dev.tagnize.com').replace(/\/$/, '');

export function getLandingUrl(path = '') {
  if (!path) return LANDING_URL;
  return `${LANDING_URL}${path.startsWith('/') ? path : `/${path}`}`;
}

export function readLandingLead() {
  try {
    return {
      nombre: sessionStorage.getItem('landing_lead_nombre') || '',
      empresa: sessionStorage.getItem('landing_lead_empresa') || '',
      email: sessionStorage.getItem('landing_lead_email') || '',
      whatsapp: sessionStorage.getItem('landing_lead_whatsapp') || '',
      volumen: sessionStorage.getItem('landing_lead_volumen') || '',
      plan: sessionStorage.getItem('landing_lead_plan') || '',
    };
  } catch {
    return {
      nombre: '',
      empresa: '',
      email: '',
      whatsapp: '',
      volumen: '',
      plan: '',
    };
  }
}

const LEAD_QUERY_KEYS = ['nombre', 'empresa', 'email', 'whatsapp', 'volumen', 'plan'];

/** Persist lead from landing redirect query (cross-domain; sessionStorage is per-origin). */
export function hydrateLandingLeadFromSearch(search) {
  const params = new URLSearchParams(search || '');
  const email = params.get('email');
  if (!email) return false;

  try {
    LEAD_QUERY_KEYS.forEach((key) => {
      const value = params.get(key);
      if (value) sessionStorage.setItem(`landing_lead_${key}`, value);
    });
    sessionStorage.setItem('landing_lead_submitted_at', new Date().toISOString());
    return true;
  } catch {
    return false;
  }
}

export function splitLandingNombre(nombre) {
  const parts = (nombre || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return { nombre: '', apellido: '' };
  if (parts.length === 1) return { nombre: parts[0], apellido: '' };
  return { nombre: parts[0], apellido: parts.slice(1).join(' ') };
}
